import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

import { Box, Flex, Select, Text } from 'core/components';
import FilteredDevicesLink from 'app/components/links/FilteredDevicesLink';

type LookbackSelectOption = {
  label: string;
  value: string;
};
type TrafficPakVizHeaderProps = {
  id: number;
  leftText: string;
  lookback: LookbackSelectOption;
  handleTimePeriodChange: (value: string) => void;
  showSelect?: boolean;
  timePeriodOptions: LookbackSelectOption[];
};

const TrafficPakVizHeader = ({
  id,
  leftText,
  lookback,
  handleTimePeriodChange,
  showSelect,
  timePeriodOptions
}: TrafficPakVizHeaderProps) => (
  <Flex justifyContent="space-between" alignItems="center" my={1}>
    <Text fontSize={14} color="muted">
      {leftText}
    </Text>

    <Flex alignItems="center">
      {showSelect && (
        <Box mr={2}>
          <Select
            options={timePeriodOptions}
            values={lookback.value}
            onChange={handleTimePeriodChange}
            placeholder="Select time period"
            width={100}
          />
        </Box>
      )}

      <FilteredDevicesLink filters={{ plan: [`${id}`], isArchived: false }}>
        <Flex alignItems="center">
          <Text mr="4px" textDecoration="underline">
            Go to Devices
          </Text>
          <FiExternalLink />
        </Flex>
      </FilteredDevicesLink>
    </Flex>
  </Flex>
);

export default TrafficPakVizHeader;
